import Typography from "components/common/Typography";
import DropDown from "components/common/dropdowns/DropDown";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import BubbleToggle from "../BubbleToggle";
import { setPayloadData } from "../PlanAssignment.slice";
import AssignTo from "./AssignTo";
import MessageToAssignee from "./MessageToAssignee";
import SelectedPlans from "./SelectedPlansList";
import "./index.scss";

export const assignmentOptions = [
  {
    id: "SHARED_PLAN",
    val: "Shared Plan"
  },
  {
    id: "INDIVIDUAL_PLAN",
    val: "Individual Plan"
  }
];

const AssignmentDetails = (props: any) => {
  const dispatch = useAppDispatch();

  const {
    currentStep,
    flow,
    payloadData: { assignmentPreference, users }
  } = useAppSelector((state) => state.PlanAssignment);

  const checkDuplicateInncodeSelected = () => {
    const selectedUsers = users?.hltId || users;
    const selectedUserInncodes: any = selectedUsers?.flatMap((user: any) => user.innCodes || user.innCode);
    return selectedUserInncodes?.filter((item: any, index: number) => selectedUserInncodes?.indexOf(item) !== index)
      .length;
  };

  return (
    <div className="assignment_details">
      <div className="assignment_details-heading">
        <Typography variant="h5" color={tokens.Text.General.PrimaryHeadline}>
          {flow?.[currentStep] !== "Assignment Details" ? "Review and Assign" : "Assignment Details"}
        </Typography>
        <BubbleToggle />
      </div>

      {checkDuplicateInncodeSelected() ? (
        flow?.[currentStep] === "Assignment Details" ? (
          <div>
            <Typography
              variant={"body2"}
              color={tokens.Text.General.PrimaryBody}
              className="selected_plans-titles-plan"
              showBold
            >
              Assign options*{" "}
            </Typography>
            <DropDown
              name={`assignmentPreference`}
              initialValue={
                assignmentOptions.find(
                  (item: any) => item.val === assignmentPreference || item.id === assignmentPreference
                )?.val || "Shared Plan"
              }
              options={assignmentOptions}
              handleChangeUpdate={(assignmentPreference: any) => dispatch(setPayloadData({ assignmentPreference }))}
              sx={{ width: "280px" }}
            />
          </div>
        ) : (
          <div className="assignment_preference">
            <Typography
              variant={"body2"}
              color={tokens.Text.General.PrimaryBody}
              className="selected_plans-titles-plan"
              showBold
            >
              Assign options
            </Typography>
            <Typography variant={"body2"} color={tokens.Icon.General.Primary}>
              {assignmentPreference}
            </Typography>
          </div>
        )
      ) : (
        <></>
      )}
      <SelectedPlans isDateEditable={flow?.[currentStep] === "Assignment Details"} />
      {flow?.[currentStep] !== "Assignment Details" && <AssignTo {...props} />}
      <MessageToAssignee isMessageEditable={flow?.[currentStep] === "Assignment Details"} />
    </div>
  );
};

export default AssignmentDetails;
